export default __webpack_public_path__ + "static/HGSE-logo-fa45cda70b680f8028291ef5abbe7c17.png";